module.exports = __webpack_public_path__ + "static/media/az.b32f4605.svg";